import type { Dispatch, SetStateAction } from "react";
import React, { useEffect, useState } from "react";
import { Popover } from "@litres/ui-kit/popover";
import { useTranslation } from "@litres-libs/i18n";
import { useHasWindow } from "@litres-libs/global-hooks";
import cn from "classnames";
import { SmartLink } from "@litres-modules/smart-link";
import { ELowerMenuItems } from "../constants";
import { SmallArrowIcon } from "../../../../static/icons/SmallArrowIcon";
import styles from "./MoreButton.module.scss";

import { EPopups } from "../../../utils/enums";
import type { LowerMenuItemType, LowerMenuIdType } from "../types";
import { MoreItems } from "../MoreItems";

export interface IMoreButtonProps {
  openedPopup?: EPopups;
  setOpenedPopup?: Dispatch<SetStateAction<EPopups>>;
  onClick: (title: string, id: LowerMenuIdType) => void;
  items: LowerMenuItemType[];
}

export const MoreButton = (props: IMoreButtonProps): JSX.Element => {
  const hasWindow = useHasWindow();
  const { openedPopup, setOpenedPopup, onClick, items } = props;

  const { t } = useTranslation();
  const [isVisibility, setIsVisibility] = useState(false);

  useEffect(() => {
    if (isVisibility && openedPopup !== EPopups.MoreMenu) {
      setIsVisibility(false);
    }
    // запрещаем прокрутку страницы при открытом окне
    document.body.style.overflow = isVisibility ? "hidden" : "";

    return (): void => {
      document.body.style.overflow = "";
    };
  }, [openedPopup, isVisibility]);

  const handleChange = (visibility: boolean): void => {
    if (visibility && setOpenedPopup) {
      setOpenedPopup(EPopups.MoreMenu);
    }
    setIsVisibility(visibility);
  };

  const handleClickMoreButton = () => {
    onClick("Еще", ELowerMenuItems.more);
  };

  return (
    <Popover
      placement="bottom"
      trigger="click"
      customCloseTriggers={["esc", "focusLost"]}
      disableArrow
      visible={isVisibility}
      offset={[0, 0]}
      portal={false}
      content={<MoreItems items={items} />}
      onVisibleChange={handleChange}
      contentClassName={styles.popoverContent}
      baseClassName={styles.popoverContentWrap}
      needForSEO={!hasWindow}
    >
      <div
        className={cn(styles.moreButton, {
          [styles.moreButton_active]: isVisibility,
        })}
        onClick={handleClickMoreButton}
        data-testid="lower-menu__more-button"
        tabIndex={0}
      >
        <SmartLink tabIndex={-1}>{t("Ещё")}</SmartLink>
        <SmallArrowIcon />
      </div>
    </Popover>
  );
};
